module.exports = __webpack_public_path__ + "img/56_85.d81aa15f.png";